
/**
 * 
 * 
 */

import React from "react";
import { Trans } from "react-i18next";
import i18n from "./../../Documental/Localization/i18n.js";
 
 
class RedirectBooking extends React.Component {

    constructor(props) {
        super(props);
        
        this.handleConfirmRedirection = this.handleConfirmRedirection.bind( this );
        this.handleSkipBooking = this.handleSkipBooking.bind( this );
    }

 
    componentDidMount() {
    }


    componentWillUnmount() {
    }

    handleConfirmRedirection(){
        if( window.mainResult.finalSuggestionRedirectToEkliinik ){
            window.location.href = window.mainResult.finalSuggestionEkliinikLink;
            return;
        }
    }

    handleSkipBooking( ){
      if( typeof this.props.onSkipBooking ){
        this.props.onSkipBooking();
      }
      return false;
    }
        
    
    render() {
        
        let buttonText  = i18n.t("Continue");
        let explainText = i18n.t("We will direct you to book an appointment.");
        
        return (<div className="form">
                <div className="col-sm-12">
                    <h2>{explainText}</h2>
                            <button 
                                type="button" 
                                className="btn btn-lg btn-default full-width dark" 
                                onClick={this.handleConfirmRedirection}
                            >
                                {buttonText}
                            </button>
                </div>
            </div>
        );
    }
}
 
export default RedirectBooking;
